import { Pipe, PipeTransform } from '@angular/core';
import { FooterLayoutType } from '@shared/enums/FooterLayoutType';

@Pipe({
    name: 'columnResponsive'
})
export class ColumnResponsivePipe implements PipeTransform {
    transform(footerLayoutType: FooterLayoutType, index: number): string {
        let width = '12';

        switch (footerLayoutType) {
            // Single column
            case FooterLayoutType.Single:
                width = '12';
                break;
            // Double column
            case FooterLayoutType.Double5050:
                width = '6';
                break;
            case FooterLayoutType.Double2575:
                if (index === 0) {
                    width = '3';
                } else {
                    width = '9';
                }
                break;
            case FooterLayoutType.Double7525:
                if (index === 0) {
                    width = '9';
                } else {
                    width = '3';
                }
                break;
            // Triple column
            case FooterLayoutType.Triple333333:
                width = '4';
                break;
            case FooterLayoutType.Triple252550:
                if (index === 2) {
                    width = '6';
                } else {
                    width = '3';
                }
                break;
            case FooterLayoutType.Triple255025:
                if (index === 1) {
                    width = '6';
                } else {
                    width = '3';
                }
                break;
            case FooterLayoutType.Triple502525:
                if (index === 0) {
                    width = '6';
                } else {
                    width = '3';
                }
                break;
            // Quadruple column
            case FooterLayoutType.Quadruple:
                width = '3';
                break;
        }

        return width;
    }
}
